import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class TemplateWizardService {
    public templateWizardCloseStream = new BehaviorSubject(false);
}
